<template>
  <main>
    <transition name="move">
      <pm-notification v-show="showNotification">
          <p slot="body"><strong>{{ mensaje }}</strong></p>
      </pm-notification>
    </transition>

    <div class="hero is-primary">
      <div class="hero-body">
        <h1 class="title has-text-centered is-size-3">
          Facturación Electrónica
        </h1>
        <div class="columns is-centered">
          <div class="column is-half">
            <div class="notification is-light">
              <div class="field">
                <label class="label">Usuario</label>
                <input class="input is-info" v-model="usuario" ref="usuario" />
              </div>
              <div class="field">
                <label class="label">Contraseña</label>
                <input class="input is-info" type="password" 
                v-model="clave" @keyup.enter="login"/>
              </div>
              <a class="button is-info is-rounded" @click="login">
                Acceder
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <PmFooter></PmFooter>
  </main>
</template>

<script>
import PmFooter from "../components/layout/Footer.vue"
import PmNotification from '../components/shared/Notification.vue'
import loginService from '../services/loginService'

export default {
  name: 'Login',

  components: {
    PmFooter,
    PmNotification
  },

  data() {
    return {
      usuario: '',
      clave: '',
      mensaje: '',
      showNotification: false
    }
  },

  mounted () {
    this.$refs.usuario.focus()
  },

  watch: {
    showNotification () {
      if (this.showNotification) {
        setTimeout(() => {
          this.showNotification = false
        }, 3000)
      }
    }
  },

  methods: {
    login() {
      const data = {
        usuario: this.usuario,
        clave: this.clave
      }
      loginService.login(data)
        .then(res => {          
          if (res.status != null && res.status == 200) {
            localStorage.setItem('token',res.data.token)
            let usuarioAuthenticated = {}
            usuarioAuthenticated = res.data
            localStorage.setItem('usuario', JSON.stringify(usuarioAuthenticated))
            this.$router.push('/menu')
          } else if (res.code != null && res.code === 'ERR_BAD_REQUEST') {
            this.showNotification = true
            this.mensaje = 'Las credenciales no son válidas'
          } else {
            this.showNotification = true
            this.mensaje = 'Error al conectar con el servidor'
          }          
        })
    },
  },
}
</script>

<style>
</style>